import { MobileNavItems } from '@ui/common/mobile-main-nav-bar.tsx';
import { useAtomValue } from 'jotai/index';
import { navbarAtom } from '@app/atoms/app/navbar.atom.ts';
import { useNavigate } from 'react-router-dom';

export const MobileNavbar = () => {
  const data = useAtomValue(navbarAtom);
  const navigate = useNavigate();

  return (
    <MobileNavItems
      subtitle={data.subtitle}
      isBack={data.isBack}
      title={data.title}
      type={data.type}
      place={data.place}
      onPress={() => navigate('/location')}
    />
  );
};
